const config = {
  KNOWLEDGE_FLAG:true,
  apiGateway: {
    URL: process.env.REACT_APP_API_URL,
    directory: process.env.REACT_APP_DIRECTORY,
    USERS_API: process.env.REACT_APP_API,
    APP_API: process.env.REACT_APP_API,
    AUTH_APPCORE:`${process.env.REACT_APP_BASE_URL}appcore`,
    AUTH_BASE:`${process.env.REACT_APP_BASE_URL}auth`,
    ASSISTANT_INSTANCE:`${process.env.REACT_APP_BASE_URL}genai`,
    FILEANALYZER_API: process.env.REACT_APP_FILEANALYZER_API,
    ASSISTANT_HISTORY:`${process.env.REACT_APP_API_BASE_URL}plugins-api/v1/history`,
    ASSISTANT_OP:`${process.env.REACT_APP_API}/genai/`,
    KNOWLEDGE_BASE:`${process.env.REACT_APP_API}/knowledgeBase/`,
    PLUGIN_BASEURL_API: `${process.env.REACT_APP_GENAI_STUDIO_URL}plugins-api/v1/weaviate`,
    PLUGIN_BUILDER: `${process.env.REACT_APP_BASE_URL}pluginbuilder`,
    endPoints: {
      LOGIN: "https://dev.infiniit.ai/plugins-api/v1/appcore/login-user",
      APP: "https://genai-studio-dev.infiniit.ai/genstudio-api/v1/genai/saveassistant",
    },
  },
  fileConfig: {
    INPUTUIVISIBLE: true,
    MANAGEBLEUSER: "ADMIN",
  },
  usersType: ["USER", "ADMIN", "SADMIN", "SIMADMIN"],
  idleTimer: {
    TIMOUT: 60000,
    SETINTERVALTIME: 60000
  },
  workflowAccessableFor: 'ankit_genaidev@niit.com'
};

export default config;
